import { Alert, Space, Typography } from 'antd';
import { Link, Navigate } from 'react-router-dom';
import { SEOHead } from '../../components/SEOHead';
import { PublicPageLayout } from '../../components/public/PublicPageLayout';
import { useAuthStore } from '../../stores/authStore';

const { Paragraph, Text } = Typography;

export default function EmailPreferencesEntryPage() {
  const authState = useAuthStore();

  if (authState.isAuthenticated) {
    return <Navigate to="/app/profile/notifications" replace />;
  }

  return (
    <>
      <SEOHead
        title="メール配信設定｜一元帳"
        description="一元帳から配信するメールの受信設定に関するご案内です。ログイン後に通知設定画面から変更できます。"
      />
      <PublicPageLayout title="メール配信設定">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Alert
            type="info"
            showIcon
            message="通知設定はログイン後に変更できます"
            description="アカウントにログインすると、通知設定画面からメール通知の受信内容を変更できます。"
          />
          <Paragraph style={{ marginBottom: 0 }}>
            メール本文の配信停止リンクからは、そのメール種別ごとの停止や一括停止を直接実行できます。
            継続的に設定を見直す場合は、ログイン後の通知設定をご利用ください。
          </Paragraph>
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Link className="public-btn public-btn--primary" to="/login">
              ログインして設定を開く
            </Link>
            <Link className="public-btn" to="/contact">
              お問い合わせ
            </Link>
          </Space>
          <Text type="secondary">
            アカウント情報が分からない場合は、お問い合わせから利用中の会社名とメールアドレスをお知らせください。
          </Text>
        </Space>
      </PublicPageLayout>
    </>
  );
}
